// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #eeeeee; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/
html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #bdbdbd; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}
*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(33 150 243 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container{
  width: 100%;
}
@media (min-width: 300px){
  .container{
    max-width: 300px;
  }
}
@media (min-width: 576px){
  .container{
    max-width: 576px;
  }
}
@media (min-width: 768px){
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1025px){
  .container{
    max-width: 1025px;
  }
}
@media (min-width: 1281px){
  .container{
    max-width: 1281px;
  }
}
@media (min-width: 1367px){
  .container{
    max-width: 1367px;
  }
}
@media (min-width: 1536px){
  .container{
    max-width: 1536px;
  }
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.\\!invisible{
  visibility: hidden !important;
}
.invisible{
  visibility: hidden;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.\\!absolute{
  position: absolute !important;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.-bottom-2{
  bottom: -0.5rem;
}
.-left-1{
  left: -0.25rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-1\\.5{
  top: -0.375rem;
}
.-top-2{
  top: -0.5rem;
}
.-top-2\\.5{
  top: -0.625rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-\\[14\\%\\]{
  bottom: 14%;
}
.bottom-\\[4\\%\\]{
  bottom: 4%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\.5{
  left: 0.375rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2\\/4{
  left: 50%;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[14\\%\\]{
  left: 14%;
}
.left-\\[2\\%\\]{
  left: 2%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-\\[14\\%\\]{
  right: 14%;
}
.right-\\[2\\%\\]{
  right: 2%;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-2\\/4{
  top: 50%;
}
.top-3{
  top: 0.75rem;
}
.top-\\[14\\%\\]{
  top: 14%;
}
.top-\\[4\\%\\]{
  top: 4%;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-50{
  z-index: 50;
}
.z-\\[10000\\]{
  z-index: 10000;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[9995\\]{
  z-index: 9995;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.row-span-1{
  grid-row: span 1 / span 1;
}
.clear-both{
  clear: both;
}
.m-0{
  margin: 0px;
}
.m-0\\.5{
  margin: 0.125rem;
}
.m-1{
  margin: 0.25rem;
}
.m-4{
  margin: 1rem;
}
.m-auto{
  margin: auto;
}
.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.mx-px{
  margin-left: 1px;
  margin-right: 1px;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.-mb-0{
  margin-bottom: -0px;
}
.-mb-3{
  margin-bottom: -0.75rem;
}
.-mb-5{
  margin-bottom: -1.25rem;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mr-4{
  margin-right: -1rem;
}
.-mt-1{
  margin-top: -0.25rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-5{
  margin-top: -1.25rem;
}
.-mt-6{
  margin-top: -1.5rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.ml-0{
  margin-left: 0px;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-24{
  margin-left: 6rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-5{
  margin-left: 1.25rem;
}
.ml-\\[1\\.2rem\\]{
  margin-left: 1.2rem;
}
.ml-\\[10px\\]{
  margin-left: 10px;
}
.ml-\\[18px\\]{
  margin-left: 18px;
}
.ml-\\[90\\%\\]{
  margin-left: 90%;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-12{
  margin-right: 3rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-28{
  margin-right: 7rem;
}
.mr-3{
  margin-right: 0.75rem;
}
.mr-3\\.5{
  margin-right: 0.875rem;
}
.mr-4{
  margin-right: 1rem;
}
.mr-5{
  margin-right: 1.25rem;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-\\[1px\\]{
  margin-top: 1px;
}
.mt-\\[20px\\]{
  margin-top: 20px;
}
.mt-\\[2px\\]{
  margin-top: 2px;
}
.mt-px{
  margin-top: 1px;
}
.box-border{
  box-sizing: border-box;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.h-0{
  height: 0px;
}
.h-0\\.5{
  height: 0.125rem;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[100px\\]{
  height: 100px;
}
.h-\\[100vh\\]{
  height: 100vh;
}
.h-\\[10px\\]{
  height: 10px;
}
.h-\\[110px\\]{
  height: 110px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[330px\\]{
  height: 330px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[44px\\]{
  height: 44px;
}
.h-\\[45px\\]{
  height: 45px;
}
.h-\\[46px\\]{
  height: 46px;
}
.h-\\[50\\%\\]{
  height: 50%;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[58px\\]{
  height: 58px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[680px\\]{
  height: 680px;
}
.h-\\[70\\%\\]{
  height: 70%;
}
.h-\\[74px\\]{
  height: 74px;
}
.h-full{
  height: 100%;
}
.h-max{
  height: max-content;
}
.h-screen{
  height: 100vh;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-96{
  max-height: 24rem;
}
.max-h-\\[100vh\\]{
  max-height: 100vh;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[32px\\]{
  max-height: 32px;
}
.max-h-\\[40px\\]{
  max-height: 40px;
}
.max-h-\\[48px\\]{
  max-height: 48px;
}
.max-h-\\[60\\%\\]{
  max-height: 60%;
}
.max-h-\\[8vh\\]{
  max-height: 8vh;
}
.max-h-\\[92vh\\]{
  max-height: 92vh;
}
.max-h-full{
  max-height: 100%;
}
.\\!min-h-\\[300px\\]{
  min-height: 300px !important;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[100vh\\]{
  min-height: 100vh;
}
.min-h-\\[12px\\]{
  min-height: 12px;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[24px\\]{
  min-height: 24px;
}
.min-h-\\[285px\\]{
  min-height: 285px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[8vh\\]{
  min-height: 8vh;
}
.min-h-fit{
  min-height: -moz-fit-content;
  min-height: fit-content;
}
.w-0{
  width: 0px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-16{
  width: 4rem;
}
.w-2\\/5{
  width: 40%;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-3\\/5{
  width: 60%;
}
.w-4{
  width: 1rem;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[100\\%\\]{
  width: 100%;
}
.w-\\[110px\\]{
  width: 110px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[15vw\\]{
  width: 15vw;
}
.w-\\[24\\%\\]{
  width: 24%;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[330px\\]{
  width: 330px;
}
.w-\\[35\\%\\]{
  width: 35%;
}
.w-\\[36\\.5\\%\\]{
  width: 36.5%;
}
.w-\\[40\\%\\]{
  width: 40%;
}
.w-\\[420px\\]{
  width: 420px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[58px\\]{
  width: 58px;
}
.w-\\[65\\%\\]{
  width: 65%;
}
.w-\\[6vw\\]{
  width: 6vw;
}
.w-\\[74px\\]{
  width: 74px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[full\\]{
  width: full;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-screen{
  width: 100vw;
}
.min-w-\\[100vw\\]{
  min-width: 100vw;
}
.min-w-\\[12px\\]{
  min-width: 12px;
}
.min-w-\\[180px\\]{
  min-width: 180px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[240px\\]{
  min-width: 240px;
}
.min-w-\\[24px\\]{
  min-width: 24px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-\\[600px\\]{
  min-width: 600px;
}
.min-w-\\[75vw\\]{
  min-width: 75vw;
}
.min-w-\\[80\\%\\]{
  min-width: 80%;
}
.min-w-\\[80vw\\]{
  min-width: 80vw;
}
.min-w-\\[82vw\\]{
  min-width: 82vw;
}
.min-w-\\[90\\%\\]{
  min-width: 90%;
}
.min-w-\\[95\\%\\]{
  min-width: 95%;
}
.min-w-full{
  min-width: 100%;
}
.max-w-\\[100vw\\]{
  max-width: 100vw;
}
.max-w-\\[250px\\]{
  max-width: 250px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[300px\\]{
  max-width: 300px;
}
.max-w-\\[32px\\]{
  max-width: 32px;
}
.max-w-\\[40px\\]{
  max-width: 40px;
}
.max-w-\\[48px\\]{
  max-width: 48px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[95\\%\\]{
  max-width: 95%;
}
.max-w-full{
  max-width: 100%;
}
.max-w-md{
  max-width: 28rem;
}
.flex-1{
  flex: 1 1;
}
.flex-none{
  flex: none;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.basis-full{
  flex-basis: 100%;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4{
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4{
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0{
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4{
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4{
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0{
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100{
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-no-drop{
  cursor: no-drop;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.\\!resize-none{
  resize: none !important;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.\\!resize{
  resize: both !important;
}
.resize{
  resize: both;
}
.appearance-none{
  appearance: none;
}
.grid-flow-row{
  grid-auto-flow: row;
}
.grid-flow-col{
  grid-auto-flow: column;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.place-items-center{
  place-items: center;
}
.content-between{
  align-content: space-between;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-items-center{
  justify-items: center;
}
.gap-0{
  gap: 0px;
}
.gap-1{
  gap: 0.25rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-44{
  gap: 11rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-5{
  column-gap: 1.25rem;
}
.gap-y-0{
  row-gap: 0px;
}
.gap-y-0\\.5{
  row-gap: 0.125rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-amber-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(255 179 0 / var(--tw-divide-opacity));
}
.divide-blue-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(30 136 229 / var(--tw-divide-opacity));
}
.divide-blue-gray-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-divide-opacity));
}
.divide-blue-gray-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(84 110 122 / var(--tw-divide-opacity));
}
.divide-brown-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(109 76 65 / var(--tw-divide-opacity));
}
.divide-cyan-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-divide-opacity));
}
.divide-deep-orange-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(244 81 30 / var(--tw-divide-opacity));
}
.divide-deep-purple-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(94 53 177 / var(--tw-divide-opacity));
}
.divide-gray-800 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(66 66 66 / var(--tw-divide-opacity));
}
.divide-green-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(67 160 71 / var(--tw-divide-opacity));
}
.divide-indigo-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-divide-opacity));
}
.divide-light-blue-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(3 155 229 / var(--tw-divide-opacity));
}
.divide-light-green-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(124 179 66 / var(--tw-divide-opacity));
}
.divide-lime-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-divide-opacity));
}
.divide-orange-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(251 140 0 / var(--tw-divide-opacity));
}
.divide-pink-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(216 27 96 / var(--tw-divide-opacity));
}
.divide-purple-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(142 36 170 / var(--tw-divide-opacity));
}
.divide-red-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(229 57 53 / var(--tw-divide-opacity));
}
.divide-teal-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(0 137 123 / var(--tw-divide-opacity));
}
.divide-yellow-600 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(253 216 53 / var(--tw-divide-opacity));
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.justify-self-end{
  justify-self: end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.\\!overflow-visible{
  overflow: visible !important;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis{
  text-overflow: ellipsis;
}
.whitespace-normal{
  white-space: normal;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-break-spaces{
  white-space: break-spaces;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.\\!rounded-full{
  border-radius: 9999px !important;
}
.\\!rounded-none{
  border-radius: 0px !important;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[7px\\]{
  border-radius: 7px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-none{
  border-radius: 0px;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-none{
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-b-xl{
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-none{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-none{
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-0{
  border-bottom-width: 0px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-r{
  border-right-width: 1px;
}
.border-r-0{
  border-right-width: 0px;
}
.border-r-2{
  border-right-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-t-2{
  border-top-width: 2px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#264390\\]{
  --tw-border-opacity: 1;
  border-color: rgb(38 67 144 / var(--tw-border-opacity));
}
.border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.border-blue-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-blue-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-blue-gray-50{
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.border-blue-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.border-brown-500{
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.border-deep-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.border-deep-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(238 238 238 / var(--tw-border-opacity));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.border-gray-400{
  --tw-border-opacity: 1;
  border-color: rgb(189 189 189 / var(--tw-border-opacity));
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(57 73 171 / var(--tw-border-opacity));
}
.border-light-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.border-light-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.border-lime-500{
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.border-teal-500{
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/80{
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.\\!border-t-transparent{
  border-top-color: transparent !important;
}
.border-b-blue-gray-100{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-b-blue-gray-200{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-r-transparent{
  border-right-color: transparent;
}
.border-t-blue-gray-100{
  --tw-border-opacity: 1;
  border-top-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-t-transparent{
  border-top-color: transparent;
}
.\\!bg-\\[\\#264390\\]{
  --tw-bg-opacity: 1 !important;
  background-color: rgb(38 67 144 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent{
  background-color: transparent !important;
}
.bg-\\[\\#264390\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(38 67 144 / var(--tw-bg-opacity));
}
.bg-\\[\\#99adeb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(153 173 235 / var(--tw-bg-opacity));
}
.bg-\\[\\#d9d9d9\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity));
}
.bg-\\[\\#ececec\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(236 236 236 / var(--tw-bg-opacity));
}
.bg-\\[\\#fde1f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(253 225 248 / var(--tw-bg-opacity));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 236 179 / var(--tw-bg-opacity));
}
.bg-amber-200{
  --tw-bg-opacity: 1;
  background-color: rgb(255 224 130 / var(--tw-bg-opacity));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10{
  background-color: rgb(255 193 7 / 0.1);
}
.bg-amber-500\\/20{
  background-color: rgb(255 193 7 / 0.2);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(187 222 251 / var(--tw-bg-opacity));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(144 202 249 / var(--tw-bg-opacity));
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10{
  background-color: rgb(33 150 243 / 0.1);
}
.bg-blue-500\\/20{
  background-color: rgb(33 150 243 / 0.2);
}
.bg-blue-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.bg-blue-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(176 190 197 / var(--tw-bg-opacity));
}
.bg-blue-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.bg-blue-gray-50\\/50{
  background-color: rgb(236 239 241 / 0.5);
}
.bg-blue-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.bg-blue-gray-500\\/10{
  background-color: rgb(96 125 139 / 0.1);
}
.bg-blue-gray-500\\/20{
  background-color: rgb(96 125 139 / 0.2);
}
.bg-brown-500{
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.bg-brown-500\\/10{
  background-color: rgb(121 85 72 / 0.1);
}
.bg-brown-500\\/20{
  background-color: rgb(121 85 72 / 0.2);
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(178 235 242 / var(--tw-bg-opacity));
}
.bg-cyan-200{
  --tw-bg-opacity: 1;
  background-color: rgb(128 222 234 / var(--tw-bg-opacity));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.bg-cyan-500\\/10{
  background-color: rgb(0 188 212 / 0.1);
}
.bg-cyan-500\\/20{
  background-color: rgb(0 188 212 / 0.2);
}
.bg-deep-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.bg-deep-orange-500\\/10{
  background-color: rgb(255 87 34 / 0.1);
}
.bg-deep-orange-500\\/20{
  background-color: rgb(255 87 34 / 0.2);
}
.bg-deep-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.bg-deep-purple-500\\/10{
  background-color: rgb(103 58 183 / 0.1);
}
.bg-deep-purple-500\\/20{
  background-color: rgb(103 58 183 / 0.2);
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(224 224 224 / var(--tw-bg-opacity));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.bg-gray-900\\/10{
  background-color: rgb(33 33 33 / 0.1);
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(200 230 201 / var(--tw-bg-opacity));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(165 214 167 / var(--tw-bg-opacity));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.bg-green-500\\/10{
  background-color: rgb(76 175 80 / 0.1);
}
.bg-green-500\\/20{
  background-color: rgb(76 175 80 / 0.2);
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(197 202 233 / var(--tw-bg-opacity));
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(159 168 218 / var(--tw-bg-opacity));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.bg-indigo-500\\/10{
  background-color: rgb(63 81 181 / 0.1);
}
.bg-indigo-500\\/20{
  background-color: rgb(63 81 181 / 0.2);
}
.bg-indigo-800{
  --tw-bg-opacity: 1;
  background-color: rgb(40 53 147 / var(--tw-bg-opacity));
}
.bg-light-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.bg-light-blue-500\\/10{
  background-color: rgb(3 169 244 / 0.1);
}
.bg-light-blue-500\\/20{
  background-color: rgb(3 169 244 / 0.2);
}
.bg-light-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.bg-light-green-500\\/10{
  background-color: rgb(139 195 74 / 0.1);
}
.bg-light-green-500\\/20{
  background-color: rgb(139 195 74 / 0.2);
}
.bg-lime-100{
  --tw-bg-opacity: 1;
  background-color: rgb(240 244 195 / var(--tw-bg-opacity));
}
.bg-lime-200{
  --tw-bg-opacity: 1;
  background-color: rgb(230 238 156 / var(--tw-bg-opacity));
}
.bg-lime-500{
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.bg-lime-500\\/10{
  background-color: rgb(205 220 57 / 0.1);
}
.bg-lime-500\\/20{
  background-color: rgb(205 220 57 / 0.2);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 224 178 / var(--tw-bg-opacity));
}
.bg-orange-200{
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 128 / var(--tw-bg-opacity));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10{
  background-color: rgb(255 152 0 / 0.1);
}
.bg-orange-500\\/20{
  background-color: rgb(255 152 0 / 0.2);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(251 140 0 / var(--tw-bg-opacity));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(248 187 208 / var(--tw-bg-opacity));
}
.bg-pink-200{
  --tw-bg-opacity: 1;
  background-color: rgb(244 143 177 / var(--tw-bg-opacity));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.bg-pink-500\\/10{
  background-color: rgb(233 30 99 / 0.1);
}
.bg-pink-500\\/20{
  background-color: rgb(233 30 99 / 0.2);
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(225 190 231 / var(--tw-bg-opacity));
}
.bg-purple-200{
  --tw-bg-opacity: 1;
  background-color: rgb(206 147 216 / var(--tw-bg-opacity));
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.bg-purple-500\\/10{
  background-color: rgb(156 39 176 / 0.1);
}
.bg-purple-500\\/20{
  background-color: rgb(156 39 176 / 0.2);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 205 210 / var(--tw-bg-opacity));
}
.bg-red-200{
  --tw-bg-opacity: 1;
  background-color: rgb(239 154 154 / var(--tw-bg-opacity));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.bg-red-500\\/10{
  background-color: rgb(244 67 54 / 0.1);
}
.bg-red-500\\/20{
  background-color: rgb(244 67 54 / 0.2);
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(178 223 219 / var(--tw-bg-opacity));
}
.bg-teal-200{
  --tw-bg-opacity: 1;
  background-color: rgb(128 203 196 / var(--tw-bg-opacity));
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.bg-teal-500\\/10{
  background-color: rgb(0 150 136 / 0.1);
}
.bg-teal-500\\/20{
  background-color: rgb(0 150 136 / 0.2);
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 249 196 / var(--tw-bg-opacity));
}
.bg-yellow-200{
  --tw-bg-opacity: 1;
  background-color: rgb(255 245 157 / var(--tw-bg-opacity));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.bg-yellow-500\\/10{
  background-color: rgb(255 235 59 / 0.1);
}
.bg-yellow-500\\/20{
  background-color: rgb(255 235 59 / 0.2);
}
.bg-opacity-60{
  --tw-bg-opacity: 0.6;
}
.bg-opacity-80{
  --tw-bg-opacity: 0.8;
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#1A1A1A80\\]{
  --tw-gradient-from: #1A1A1A80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 26 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600{
  --tw-gradient-from: #ffb300 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 179 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #1e88e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 136 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-gray-600{
  --tw-gradient-from: #546e7a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(84 110 122 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brown-600{
  --tw-gradient-from: #6d4c41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 76 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600{
  --tw-gradient-from: #00acc1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 172 193 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-orange-600{
  --tw-gradient-from: #f4511e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 81 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-purple-600{
  --tw-gradient-from: #5e35b1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 53 177 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600{
  --tw-gradient-from: #757575 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(117 117 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900{
  --tw-gradient-from: #212121 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 33 33 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #43a047 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 160 71 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #3949ab var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(57 73 171 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-blue-600{
  --tw-gradient-from: #039be5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 155 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-green-600{
  --tw-gradient-from: #7cb342 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 179 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-600{
  --tw-gradient-from: #c0ca33 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 202 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600{
  --tw-gradient-from: #fb8c00 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 140 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600{
  --tw-gradient-from: #d81b60 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 27 96 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #8e24aa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(142 36 170 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600{
  --tw-gradient-from: #e53935 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 57 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600{
  --tw-gradient-from: #00897b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 137 123 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600{
  --tw-gradient-from: #fdd835 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 216 53 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#1A1A1A40\\]{
  --tw-gradient-to: rgb(26 26 26 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1A1A1A40 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-amber-400{
  --tw-gradient-to: #ffca28 var(--tw-gradient-to-position);
}
.to-blue-400{
  --tw-gradient-to: #42a5f5 var(--tw-gradient-to-position);
}
.to-blue-gray-400{
  --tw-gradient-to: #78909c var(--tw-gradient-to-position);
}
.to-brown-400{
  --tw-gradient-to: #8d6e63 var(--tw-gradient-to-position);
}
.to-cyan-400{
  --tw-gradient-to: #26c6da var(--tw-gradient-to-position);
}
.to-deep-orange-400{
  --tw-gradient-to: #ff7043 var(--tw-gradient-to-position);
}
.to-deep-purple-400{
  --tw-gradient-to: #7e57c2 var(--tw-gradient-to-position);
}
.to-gray-400{
  --tw-gradient-to: #bdbdbd var(--tw-gradient-to-position);
}
.to-gray-800{
  --tw-gradient-to: #424242 var(--tw-gradient-to-position);
}
.to-green-400{
  --tw-gradient-to: #66bb6a var(--tw-gradient-to-position);
}
.to-indigo-400{
  --tw-gradient-to: #5c6bc0 var(--tw-gradient-to-position);
}
.to-light-blue-400{
  --tw-gradient-to: #29b6f6 var(--tw-gradient-to-position);
}
.to-light-green-400{
  --tw-gradient-to: #9ccc65 var(--tw-gradient-to-position);
}
.to-lime-400{
  --tw-gradient-to: #d4e157 var(--tw-gradient-to-position);
}
.to-orange-400{
  --tw-gradient-to: #ffa726 var(--tw-gradient-to-position);
}
.to-pink-400{
  --tw-gradient-to: #ec407a var(--tw-gradient-to-position);
}
.to-purple-400{
  --tw-gradient-to: #ab47bc var(--tw-gradient-to-position);
}
.to-red-400{
  --tw-gradient-to: #ef5350 var(--tw-gradient-to-position);
}
.to-teal-400{
  --tw-gradient-to: #26a69a var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-yellow-400{
  --tw-gradient-to: #ffee58 var(--tw-gradient-to-position);
}
.bg-clip-border{
  background-clip: border-box;
}
.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-center{
  object-position: center;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-\\[0\\.45rem\\]{
  padding: 0.45rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-px{
  padding-left: 1px;
  padding-right: 1px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[0\\.55rem\\]{
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
}
.py-\\[0\\.8rem\\]{
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}
.py-\\[8\\%\\]{
  padding-top: 8%;
  padding-bottom: 8%;
}
.\\!pr-7{
  padding-right: 1.75rem !important;
}
.\\!pr-9{
  padding-right: 2.25rem !important;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-1\\.5{
  padding-bottom: 0.375rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-28{
  padding-bottom: 7rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-20{
  padding-left: 5rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pl-\\[45\\%\\]{
  padding-left: 45%;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-12{
  padding-right: 3rem;
}
.pr-14{
  padding-right: 3.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-5{
  padding-right: 1.25rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 0.125rem;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-\\[9px\\]{
  padding-top: 9px;
}
.pt-px{
  padding-top: 1px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-start{
  text-align: start;
}
.align-top{
  vertical-align: top;
}
.align-middle{
  vertical-align: middle;
}
.font-\\[\\'poppins\\'\\]{
  font-family: 'poppins';
}
.font-\\[poppins\\]{
  font-family: poppins;
}
.font-poppins{
  font-family: Poppins, sans-serif;
}
.font-sans{
  font-family: Roboto, sans-serif;
}
.\\!text-\\[11px\\]{
  font-size: 11px !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.\\!capitalize{
  text-transform: capitalize !important;
}
.capitalize{
  text-transform: capitalize;
}
.ordinal{
  --tw-ordinal: ordinal;
  font-feature-settings: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.\\!leading-tight{
  line-height: 1.25 !important;
}
.leading-\\[1\\.3\\]{
  line-height: 1.3;
}
.leading-\\[3\\.75\\]{
  line-height: 3.75;
}
.leading-\\[4\\.1\\]{
  line-height: 4.1;
}
.leading-\\[4\\.25\\]{
  line-height: 4.25;
}
.leading-\\[4\\.875\\]{
  line-height: 4.875;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-normal{
  letter-spacing: 0em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.\\!text-black{
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-white{
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#264390\\]{
  --tw-text-opacity: 1;
  color: rgb(38 67 144 / var(--tw-text-opacity));
}
.text-\\[\\#FF0000\\]{
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(255 179 0 / var(--tw-text-opacity));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(30 136 229 / var(--tw-text-opacity));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(21 101 192 / var(--tw-text-opacity));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(13 71 161 / var(--tw-text-opacity));
}
.text-blue-gray-400{
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.text-blue-gray-500{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.text-blue-gray-700{
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity));
}
.text-blue-gray-900{
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.text-brown-500{
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.text-brown-700{
  --tw-text-opacity: 1;
  color: rgb(93 64 55 / var(--tw-text-opacity));
}
.text-brown-900{
  --tw-text-opacity: 1;
  color: rgb(62 39 35 / var(--tw-text-opacity));
}
.text-current{
  color: currentColor;
}
.text-cyan-500{
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(0 172 193 / var(--tw-text-opacity));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.text-cyan-900{
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}
.text-deep-orange-500{
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.text-deep-orange-700{
  --tw-text-opacity: 1;
  color: rgb(230 74 25 / var(--tw-text-opacity));
}
.text-deep-orange-900{
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity));
}
.text-deep-purple-500{
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.text-deep-purple-700{
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity));
}
.text-deep-purple-900{
  --tw-text-opacity: 1;
  color: rgb(49 27 146 / var(--tw-text-opacity));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(117 117 117 / var(--tw-text-opacity));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(66 66 66 / var(--tw-text-opacity));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(67 160 71 / var(--tw-text-opacity));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(27 94 32 / var(--tw-text-opacity));
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(57 73 171 / var(--tw-text-opacity));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(26 35 126 / var(--tw-text-opacity));
}
.text-inherit{
  color: inherit;
}
.text-light-blue-500{
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.text-light-blue-700{
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity));
}
.text-light-blue-900{
  --tw-text-opacity: 1;
  color: rgb(1 87 155 / var(--tw-text-opacity));
}
.text-light-green-500{
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.text-light-green-700{
  --tw-text-opacity: 1;
  color: rgb(104 159 56 / var(--tw-text-opacity));
}
.text-light-green-900{
  --tw-text-opacity: 1;
  color: rgb(51 105 30 / var(--tw-text-opacity));
}
.text-lime-500{
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.text-lime-600{
  --tw-text-opacity: 1;
  color: rgb(192 202 51 / var(--tw-text-opacity));
}
.text-lime-700{
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.text-lime-900{
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(251 140 0 / var(--tw-text-opacity));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity));
}
.text-orange-900{
  --tw-text-opacity: 1;
  color: rgb(230 81 0 / var(--tw-text-opacity));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(216 27 96 / var(--tw-text-opacity));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity));
}
.text-pink-900{
  --tw-text-opacity: 1;
  color: rgb(136 14 79 / var(--tw-text-opacity));
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(142 36 170 / var(--tw-text-opacity));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity));
}
.text-purple-900{
  --tw-text-opacity: 1;
  color: rgb(74 20 140 / var(--tw-text-opacity));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(183 28 28 / var(--tw-text-opacity));
}
.text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(0 137 123 / var(--tw-text-opacity));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity));
}
.text-teal-900{
  --tw-text-opacity: 1;
  color: rgb(0 77 64 / var(--tw-text-opacity));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(253 216 53 / var(--tw-text-opacity));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(245 127 23 / var(--tw-text-opacity));
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(189 189 189 / var(--tw-placeholder-opacity));
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20{
  --tw-shadow-color: rgb(255 193 7 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/40{
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20{
  --tw-shadow-color: rgb(33 150 243 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/40{
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/10{
  --tw-shadow-color: rgb(96 125 139 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/20{
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/40{
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-900\\/10{
  --tw-shadow-color: rgb(38 50 56 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/20{
  --tw-shadow-color: rgb(121 85 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/40{
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20{
  --tw-shadow-color: rgb(0 188 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/40{
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/20{
  --tw-shadow-color: rgb(255 87 34 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/40{
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/20{
  --tw-shadow-color: rgb(103 58 183 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/40{
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/10{
  --tw-shadow-color: rgb(33 33 33 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-900\\/20{
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20{
  --tw-shadow-color: rgb(76 175 80 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/40{
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20{
  --tw-shadow-color: rgb(63 81 181 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/40{
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/20{
  --tw-shadow-color: rgb(3 169 244 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/40{
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/20{
  --tw-shadow-color: rgb(139 195 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/40{
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/20{
  --tw-shadow-color: rgb(205 220 57 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/40{
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20{
  --tw-shadow-color: rgb(255 152 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/40{
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20{
  --tw-shadow-color: rgb(233 30 99 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/40{
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20{
  --tw-shadow-color: rgb(156 39 176 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/40{
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20{
  --tw-shadow-color: rgb(244 67 54 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/40{
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20{
  --tw-shadow-color: rgb(0 150 136 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/40{
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/20{
  --tw-shadow-color: rgb(255 235 59 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/40{
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-0{
  outline-width: 0px;
}
.outline-blue-500{
  outline-color: #2196f3;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200{
  --tw-backdrop-saturate: saturate(2);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.content-\\[\\'\\'\\]{
  --tw-content: '';
  content: var(--tw-content);
}
.\\[-webkit-appearance\\:none\\]{
  -webkit-appearance: none;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.top-bar li {
  height: 25px;
  border-radius: 5px;
}

.dashboard-card :hover {
  /* background: #264390; */
  width: '100%';
}

.dashboard-card :hover .visit-button {
  background: #FFF;
  color: #264390;
}

.dashboard-card :hover .visit-button button,
.visit-icon {
  background: #FFF;
  color: #264390;
}

.dashboard-card :hover .visit-button button ,
.visit-icon {
  color: #264390;
}

.visit-button {
  color: #fff;
}

.dashboardbutton :hover .visit-button , .visit-icon{
  background: #FFF;
  color: #264390;
}

@media (max-width: 1366px) {

  .res_height {
    height: 400px !important;
  }
}

@media (-webkit-min-device-pixel-ratio: 0.80) {
  .modal1 {
    max-height: 20vw;
  }
}


input::placeholder {
  color: gray;
  opacity: 1;
}

input[required]+label {
  position: relative;
  left: -170px;
  /* move the label left and place it inside the input */
  color: #757575;
  /* placeholder color here */
}

input[required]+label:after {
  content: '*';
  color: red;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important
}

.container-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.file_open {
  transition: top 0.5s;
  top: 150px;
}

.file_shrink_main:hover .file_open {
  top: 90px;
}

/* .overflow-hidden{
  overflow: visible !important;
  overflow: auto !important;
} */

/* Alert Popup text wrapping fix */
.alert-popup-message {
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
  max-width: 100% !important;
  width: 100% !important;
  white-space: normal !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

/* Ensure Material Tailwind Alert content wraps */
[class*="material-tailwind"] .alert-content,
[class*="material-tailwind"] > div {
  max-width: 100% !important;
  overflow: hidden !important;
  word-wrap: break-word !important;
}
.before\\:pointer-events-none::before{
  content: var(--tw-content);
  pointer-events: none;
}
.before\\:absolute::before{
  content: var(--tw-content);
  position: absolute;
}
.before\\:left-2\\/4::before{
  content: var(--tw-content);
  left: 50%;
}
.before\\:top-2\\/4::before{
  content: var(--tw-content);
  top: 50%;
}
.before\\:mr-1::before{
  content: var(--tw-content);
  margin-right: 0.25rem;
}
.before\\:mt-\\[6\\.5px\\]::before{
  content: var(--tw-content);
  margin-top: 6.5px;
}
.before\\:box-border::before{
  content: var(--tw-content);
  box-sizing: border-box;
}
.before\\:block::before{
  content: var(--tw-content);
  display: block;
}
.before\\:h-1::before{
  content: var(--tw-content);
  height: 0.25rem;
}
.before\\:h-1\\.5::before{
  content: var(--tw-content);
  height: 0.375rem;
}
.before\\:h-10::before{
  content: var(--tw-content);
  height: 2.5rem;
}
.before\\:h-12::before{
  content: var(--tw-content);
  height: 3rem;
}
.before\\:w-10::before{
  content: var(--tw-content);
  width: 2.5rem;
}
.before\\:w-12::before{
  content: var(--tw-content);
  width: 3rem;
}
.before\\:w-2::before{
  content: var(--tw-content);
  width: 0.5rem;
}
.before\\:w-2\\.5::before{
  content: var(--tw-content);
  width: 0.625rem;
}
.before\\:-translate-x-2\\/4::before{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:-translate-y-2\\/4::before{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.before\\:rounded-full::before{
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:rounded-tl-md::before{
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
}
.before\\:border-l::before{
  content: var(--tw-content);
  border-left-width: 1px;
}
.before\\:border-l-2::before{
  content: var(--tw-content);
  border-left-width: 2px;
}
.before\\:border-t::before{
  content: var(--tw-content);
  border-top-width: 1px;
}
.before\\:border-t-2::before{
  content: var(--tw-content);
  border-top-width: 2px;
}
.before\\:\\!border-blue-gray-200::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}
.before\\:border-amber-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.before\\:border-black::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.before\\:border-blue-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.before\\:border-blue-gray-200::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.before\\:border-blue-gray-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.before\\:border-brown-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.before\\:border-cyan-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.before\\:border-deep-orange-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.before\\:border-deep-purple-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.before\\:border-gray-900::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.before\\:border-green-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.before\\:border-indigo-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.before\\:border-light-blue-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.before\\:border-light-green-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.before\\:border-lime-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.before\\:border-orange-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.before\\:border-pink-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.before\\:border-purple-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.before\\:border-red-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.before\\:border-teal-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.before\\:border-transparent::before{
  content: var(--tw-content);
  border-color: transparent;
}
.before\\:border-white::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.before\\:border-yellow-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.before\\:border-l-transparent::before{
  content: var(--tw-content);
  border-left-color: transparent;
}
.before\\:border-t-transparent::before{
  content: var(--tw-content);
  border-top-color: transparent;
}
.before\\:bg-blue-gray-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.before\\:opacity-0::before{
  content: var(--tw-content);
  opacity: 0;
}
.before\\:transition-all::before{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.before\\:transition-opacity::before{
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:pointer-events-none::after{
  content: var(--tw-content);
  pointer-events: none;
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:-bottom-0::after{
  content: var(--tw-content);
  bottom: -0px;
}
.after\\:-bottom-1::after{
  content: var(--tw-content);
  bottom: -0.25rem;
}
.after\\:-bottom-1\\.5::after{
  content: var(--tw-content);
  bottom: -0.375rem;
}
.after\\:-bottom-2::after{
  content: var(--tw-content);
  bottom: -0.5rem;
}
.after\\:-bottom-2\\.5::after{
  content: var(--tw-content);
  bottom: -0.625rem;
}
.after\\:ml-1::after{
  content: var(--tw-content);
  margin-left: 0.25rem;
}
.after\\:mt-\\[6\\.5px\\]::after{
  content: var(--tw-content);
  margin-top: 6.5px;
}
.after\\:box-border::after{
  content: var(--tw-content);
  box-sizing: border-box;
}
.after\\:block::after{
  content: var(--tw-content);
  display: block;
}
.after\\:h-1::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.after\\:h-1\\.5::after{
  content: var(--tw-content);
  height: 0.375rem;
}
.after\\:w-2::after{
  content: var(--tw-content);
  width: 0.5rem;
}
.after\\:w-2\\.5::after{
  content: var(--tw-content);
  width: 0.625rem;
}
.after\\:w-full::after{
  content: var(--tw-content);
  width: 100%;
}
.after\\:flex-grow::after{
  content: var(--tw-content);
  flex-grow: 1;
}
.after\\:scale-x-0::after{
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:scale-x-100::after{
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-tr-md::after{
  content: var(--tw-content);
  border-top-right-radius: 0.375rem;
}
.after\\:border-b-2::after{
  content: var(--tw-content);
  border-bottom-width: 2px;
}
.after\\:border-r::after{
  content: var(--tw-content);
  border-right-width: 1px;
}
.after\\:border-r-2::after{
  content: var(--tw-content);
  border-right-width: 2px;
}
.after\\:border-t::after{
  content: var(--tw-content);
  border-top-width: 1px;
}
.after\\:border-t-2::after{
  content: var(--tw-content);
  border-top-width: 2px;
}
.after\\:\\!border-blue-gray-200::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}
.after\\:border-\\[\\#163380\\]::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(22 51 128 / var(--tw-border-opacity));
}
.after\\:border-amber-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.after\\:border-black::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.after\\:border-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-200::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-50::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.after\\:border-blue-gray-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.after\\:border-brown-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.after\\:border-cyan-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.after\\:border-deep-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.after\\:border-deep-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.after\\:border-gray-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.after\\:border-gray-900::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.after\\:border-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.after\\:border-indigo-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.after\\:border-light-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.after\\:border-light-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.after\\:border-lime-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.after\\:border-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.after\\:border-pink-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.after\\:border-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.after\\:border-red-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.after\\:border-teal-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.after\\:border-transparent::after{
  content: var(--tw-content);
  border-color: transparent;
}
.after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.after\\:border-yellow-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.after\\:border-r-transparent::after{
  content: var(--tw-content);
  border-right-color: transparent;
}
.after\\:border-t-transparent::after{
  content: var(--tw-content);
  border-top-color: transparent;
}
.after\\:transition-all::after{
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:transition-transform::after{
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:duration-300::after{
  content: var(--tw-content);
  transition-duration: 300ms;
}
.checked\\:border-amber-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.checked\\:border-blue-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.checked\\:border-blue-gray-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.checked\\:border-brown-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.checked\\:border-cyan-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.checked\\:border-deep-orange-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.checked\\:border-deep-purple-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.checked\\:border-gray-900:checked{
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.checked\\:border-green-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.checked\\:border-indigo-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.checked\\:border-light-blue-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.checked\\:border-light-green-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.checked\\:border-lime-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.checked\\:border-orange-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.checked\\:border-pink-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.checked\\:border-purple-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.checked\\:border-red-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.checked\\:border-teal-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.checked\\:border-yellow-500:checked{
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.checked\\:bg-amber-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.checked\\:bg-blue-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.checked\\:bg-blue-gray-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.checked\\:bg-brown-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.checked\\:bg-cyan-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.checked\\:bg-deep-orange-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.checked\\:bg-deep-purple-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.checked\\:bg-gray-900:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.checked\\:bg-green-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.checked\\:bg-indigo-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.checked\\:bg-light-blue-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.checked\\:bg-light-green-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.checked\\:bg-lime-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.checked\\:bg-orange-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.checked\\:bg-pink-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.checked\\:bg-purple-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.checked\\:bg-red-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.checked\\:bg-teal-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.checked\\:bg-yellow-500:checked{
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-amber-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-blue-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-blue-gray-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-brown-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-cyan-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-deep-orange-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-deep-purple-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-gray-900:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-green-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-indigo-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-light-blue-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-light-green-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-lime-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-orange-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-pink-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-purple-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-red-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-teal-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.checked\\:before\\:bg-yellow-500:checked::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.placeholder-shown\\:border:placeholder-shown{
  border-width: 1px;
}
.placeholder-shown\\:border-blue-gray-200:placeholder-shown{
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-green-500:placeholder-shown{
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-red-500:placeholder-shown{
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-blue-gray-200:placeholder-shown{
  --tw-border-opacity: 1;
  border-top-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-green-500:placeholder-shown{
  --tw-border-opacity: 1;
  border-top-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.placeholder-shown\\:border-t-red-500:placeholder-shown{
  --tw-border-opacity: 1;
  border-top-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:cursor-pointer:hover{
  cursor: pointer;
}
.hover\\:bg-amber-500\\/10:hover{
  background-color: rgb(255 193 7 / 0.1);
}
.hover\\:bg-amber-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 179 0 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-500\\/10:hover{
  background-color: rgb(33 150 243 / 0.1);
}
.hover\\:bg-blue-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 136 229 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.hover\\:bg-blue-gray-500\\/10:hover{
  background-color: rgb(96 125 139 / 0.1);
}
.hover\\:bg-brown-500\\/10:hover{
  background-color: rgb(121 85 72 / 0.1);
}
.hover\\:bg-cyan-500\\/10:hover{
  background-color: rgb(0 188 212 / 0.1);
}
.hover\\:bg-cyan-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 172 193 / var(--tw-bg-opacity));
}
.hover\\:bg-deep-orange-500\\/10:hover{
  background-color: rgb(255 87 34 / 0.1);
}
.hover\\:bg-deep-purple-500\\/10:hover{
  background-color: rgb(103 58 183 / 0.1);
}
.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 238 238 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(117 117 117 / var(--tw-bg-opacity));
}
.hover\\:bg-gray-900\\/10:hover{
  background-color: rgb(33 33 33 / 0.1);
}
.hover\\:bg-green-500\\/10:hover{
  background-color: rgb(76 175 80 / 0.1);
}
.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 160 71 / var(--tw-bg-opacity));
}
.hover\\:bg-indigo-500\\/10:hover{
  background-color: rgb(63 81 181 / 0.1);
}
.hover\\:bg-indigo-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(57 73 171 / var(--tw-bg-opacity));
}
.hover\\:bg-light-blue-500\\/10:hover{
  background-color: rgb(3 169 244 / 0.1);
}
.hover\\:bg-light-green-500\\/10:hover{
  background-color: rgb(139 195 74 / 0.1);
}
.hover\\:bg-lime-500\\/10:hover{
  background-color: rgb(205 220 57 / 0.1);
}
.hover\\:bg-lime-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 202 51 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-500\\/10:hover{
  background-color: rgb(255 152 0 / 0.1);
}
.hover\\:bg-orange-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(251 140 0 / var(--tw-bg-opacity));
}
.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 124 0 / var(--tw-bg-opacity));
}
.hover\\:bg-pink-500\\/10:hover{
  background-color: rgb(233 30 99 / 0.1);
}
.hover\\:bg-pink-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(216 27 96 / var(--tw-bg-opacity));
}
.hover\\:bg-purple-500\\/10:hover{
  background-color: rgb(156 39 176 / 0.1);
}
.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(142 36 170 / var(--tw-bg-opacity));
}
.hover\\:bg-red-500\\/10:hover{
  background-color: rgb(244 67 54 / 0.1);
}
.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 57 53 / var(--tw-bg-opacity));
}
.hover\\:bg-teal-500\\/10:hover{
  background-color: rgb(0 150 136 / 0.1);
}
.hover\\:bg-teal-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(0 137 123 / var(--tw-bg-opacity));
}
.hover\\:bg-transparent:hover{
  background-color: transparent;
}
.hover\\:bg-white\\/10:hover{
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-yellow-500\\/10:hover{
  background-color: rgb(255 235 59 / 0.1);
}
.hover\\:bg-yellow-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 216 53 / var(--tw-bg-opacity));
}
.hover\\:bg-opacity-80:hover{
  --tw-bg-opacity: 0.8;
}
.hover\\:\\!text-blue-700:hover{
  --tw-text-opacity: 1 !important;
  color: rgb(25 118 210 / var(--tw-text-opacity)) !important;
}
.hover\\:text-\\[\\#264390\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(38 67 144 / var(--tw-text-opacity));
}
.hover\\:text-amber-700:hover{
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity));
}
.hover\\:text-blue-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.hover\\:text-blue-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.hover\\:text-cyan-700:hover{
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity));
}
.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(48 63 159 / var(--tw-text-opacity));
}
.hover\\:text-light-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.hover\\:text-lime-700:hover{
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.hover\\:text-orange-700:hover{
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity));
}
.hover\\:text-pink-700:hover{
  --tw-text-opacity: 1;
  color: rgb(194 24 91 / var(--tw-text-opacity));
}
.hover\\:text-purple-700:hover{
  --tw-text-opacity: 1;
  color: rgb(123 31 162 / var(--tw-text-opacity));
}
.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity));
}
.hover\\:text-teal-700:hover{
  --tw-text-opacity: 1;
  color: rgb(0 121 107 / var(--tw-text-opacity));
}
.hover\\:text-yellow-700:hover{
  --tw-text-opacity: 1;
  color: rgb(251 192 45 / var(--tw-text-opacity));
}
.hover\\:opacity-75:hover{
  opacity: 0.75;
}
.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-amber-500\\/40:hover{
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-500\\/40:hover{
  --tw-shadow-color: rgb(33 150 243 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-gray-500\\/20:hover{
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-blue-gray-500\\/40:hover{
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-brown-500\\/40:hover{
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-cyan-500\\/40:hover{
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-deep-orange-500\\/40:hover{
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-deep-purple-500\\/40:hover{
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-gray-900\\/20:hover{
  --tw-shadow-color: rgb(33 33 33 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-green-500\\/40:hover{
  --tw-shadow-color: rgb(76 175 80 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-indigo-500\\/40:hover{
  --tw-shadow-color: rgb(63 81 181 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-light-blue-500\\/40:hover{
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-light-green-500\\/40:hover{
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-lime-500\\/40:hover{
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-orange-500\\/40:hover{
  --tw-shadow-color: rgb(255 152 0 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-pink-500\\/40:hover{
  --tw-shadow-color: rgb(233 30 99 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-purple-500\\/40:hover{
  --tw-shadow-color: rgb(156 39 176 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-red-500\\/40:hover{
  --tw-shadow-color: rgb(244 67 54 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-teal-500\\/40:hover{
  --tw-shadow-color: rgb(0 150 136 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-yellow-500\\/40:hover{
  --tw-shadow-color: rgb(255 235 59 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:before\\:opacity-10:hover::before{
  content: var(--tw-content);
  opacity: 0.1;
}
.focus\\:scale-110:focus{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.focus\\:border-2:focus{
  border-width: 2px;
}
.focus\\:border-\\[\\#163380\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(22 51 128 / var(--tw-border-opacity));
}
.focus\\:border-amber-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.focus\\:border-black:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.focus\\:border-blue-gray-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.focus\\:border-blue-gray-900:focus{
  --tw-border-opacity: 1;
  border-color: rgb(38 50 56 / var(--tw-border-opacity));
}
.focus\\:border-brown-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.focus\\:border-cyan-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.focus\\:border-deep-orange-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.focus\\:border-deep-purple-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.focus\\:border-gray-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(158 158 158 / var(--tw-border-opacity));
}
.focus\\:border-gray-900:focus{
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.focus\\:border-green-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.focus\\:border-light-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.focus\\:border-light-green-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.focus\\:border-lime-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.focus\\:border-orange-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.focus\\:border-pink-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.focus\\:border-purple-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.focus\\:border-red-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.focus\\:border-teal-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.focus\\:border-white:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.focus\\:border-yellow-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.focus\\:border-t-transparent:focus{
  border-top-color: transparent;
}
.focus\\:bg-amber-100\\/50:focus{
  background-color: rgb(255 236 179 / 0.5);
}
.focus\\:bg-blue-100\\/50:focus{
  background-color: rgb(187 222 251 / 0.5);
}
.focus\\:bg-blue-gray-50:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.focus\\:bg-cyan-100\\/50:focus{
  background-color: rgb(178 235 242 / 0.5);
}
.focus\\:bg-green-100\\/50:focus{
  background-color: rgb(200 230 201 / 0.5);
}
.focus\\:bg-indigo-100\\/50:focus{
  background-color: rgb(197 202 233 / 0.5);
}
.focus\\:bg-lime-100\\/50:focus{
  background-color: rgb(240 244 195 / 0.5);
}
.focus\\:bg-orange-100\\/50:focus{
  background-color: rgb(255 224 178 / 0.5);
}
.focus\\:bg-pink-100\\/50:focus{
  background-color: rgb(248 187 208 / 0.5);
}
.focus\\:bg-purple-100\\/50:focus{
  background-color: rgb(225 190 231 / 0.5);
}
.focus\\:bg-red-100\\/50:focus{
  background-color: rgb(255 205 210 / 0.5);
}
.focus\\:bg-teal-100\\/50:focus{
  background-color: rgb(178 223 219 / 0.5);
}
.focus\\:bg-transparent:focus{
  background-color: transparent;
}
.focus\\:bg-yellow-100\\/50:focus{
  background-color: rgb(255 249 196 / 0.5);
}
.focus\\:bg-opacity-80:focus{
  --tw-bg-opacity: 0.8;
}
.focus\\:text-blue-gray-500:focus{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.focus\\:text-blue-gray-900:focus{
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.focus\\:opacity-\\[0\\.85\\]:focus{
  opacity: 0.85;
}
.focus\\:shadow-none:focus{
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:outline-0:focus{
  outline-width: 0px;
}
.focus\\:ring:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-amber-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 224 130 / var(--tw-ring-opacity));
}
.focus\\:ring-amber-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 193 7 / var(--tw-ring-opacity));
}
.focus\\:ring-amber-500\\/20:focus{
  --tw-ring-color: rgb(255 193 7 / 0.2);
}
.focus\\:ring-amber-500\\/50:focus{
  --tw-ring-color: rgb(255 193 7 / 0.5);
}
.focus\\:ring-blue-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 202 249 / var(--tw-ring-opacity));
}
.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(33 150 243 / var(--tw-ring-opacity));
}
.focus\\:ring-blue-500\\/20:focus{
  --tw-ring-color: rgb(33 150 243 / 0.2);
}
.focus\\:ring-blue-500\\/50:focus{
  --tw-ring-color: rgb(33 150 243 / 0.5);
}
.focus\\:ring-blue-gray-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(176 190 197 / var(--tw-ring-opacity));
}
.focus\\:ring-brown-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 170 164 / var(--tw-ring-opacity));
}
.focus\\:ring-cyan-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 222 234 / var(--tw-ring-opacity));
}
.focus\\:ring-cyan-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 188 212 / var(--tw-ring-opacity));
}
.focus\\:ring-cyan-500\\/20:focus{
  --tw-ring-color: rgb(0 188 212 / 0.2);
}
.focus\\:ring-cyan-500\\/50:focus{
  --tw-ring-color: rgb(0 188 212 / 0.5);
}
.focus\\:ring-deep-orange-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 171 145 / var(--tw-ring-opacity));
}
.focus\\:ring-deep-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(179 157 219 / var(--tw-ring-opacity));
}
.focus\\:ring-gray-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 224 224 / var(--tw-ring-opacity));
}
.focus\\:ring-green-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(165 214 167 / var(--tw-ring-opacity));
}
.focus\\:ring-green-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(76 175 80 / var(--tw-ring-opacity));
}
.focus\\:ring-green-500\\/20:focus{
  --tw-ring-color: rgb(76 175 80 / 0.2);
}
.focus\\:ring-green-500\\/50:focus{
  --tw-ring-color: rgb(76 175 80 / 0.5);
}
.focus\\:ring-indigo-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(159 168 218 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 81 181 / var(--tw-ring-opacity));
}
.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(63 81 181 / 0.2);
}
.focus\\:ring-indigo-500\\/50:focus{
  --tw-ring-color: rgb(63 81 181 / 0.5);
}
.focus\\:ring-light-blue-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 212 250 / var(--tw-ring-opacity));
}
.focus\\:ring-light-green-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 225 165 / var(--tw-ring-opacity));
}
.focus\\:ring-lime-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 238 156 / var(--tw-ring-opacity));
}
.focus\\:ring-lime-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(205 220 57 / var(--tw-ring-opacity));
}
.focus\\:ring-lime-500\\/20:focus{
  --tw-ring-color: rgb(205 220 57 / 0.2);
}
.focus\\:ring-lime-500\\/50:focus{
  --tw-ring-color: rgb(205 220 57 / 0.5);
}
.focus\\:ring-orange-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 204 128 / var(--tw-ring-opacity));
}
.focus\\:ring-orange-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 152 0 / var(--tw-ring-opacity));
}
.focus\\:ring-orange-500\\/20:focus{
  --tw-ring-color: rgb(255 152 0 / 0.2);
}
.focus\\:ring-orange-500\\/50:focus{
  --tw-ring-color: rgb(255 152 0 / 0.5);
}
.focus\\:ring-pink-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 143 177 / var(--tw-ring-opacity));
}
.focus\\:ring-pink-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 30 99 / var(--tw-ring-opacity));
}
.focus\\:ring-pink-500\\/20:focus{
  --tw-ring-color: rgb(233 30 99 / 0.2);
}
.focus\\:ring-pink-500\\/50:focus{
  --tw-ring-color: rgb(233 30 99 / 0.5);
}
.focus\\:ring-purple-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(206 147 216 / var(--tw-ring-opacity));
}
.focus\\:ring-purple-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 39 176 / var(--tw-ring-opacity));
}
.focus\\:ring-purple-500\\/20:focus{
  --tw-ring-color: rgb(156 39 176 / 0.2);
}
.focus\\:ring-purple-500\\/50:focus{
  --tw-ring-color: rgb(156 39 176 / 0.5);
}
.focus\\:ring-red-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 154 154 / var(--tw-ring-opacity));
}
.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 67 54 / var(--tw-ring-opacity));
}
.focus\\:ring-red-500\\/20:focus{
  --tw-ring-color: rgb(244 67 54 / 0.2);
}
.focus\\:ring-red-500\\/50:focus{
  --tw-ring-color: rgb(244 67 54 / 0.5);
}
.focus\\:ring-teal-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 203 196 / var(--tw-ring-opacity));
}
.focus\\:ring-teal-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 150 136 / var(--tw-ring-opacity));
}
.focus\\:ring-teal-500\\/20:focus{
  --tw-ring-color: rgb(0 150 136 / 0.2);
}
.focus\\:ring-teal-500\\/50:focus{
  --tw-ring-color: rgb(0 150 136 / 0.5);
}
.focus\\:ring-white\\/50:focus{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.focus\\:ring-yellow-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 245 157 / var(--tw-ring-opacity));
}
.focus\\:ring-yellow-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 235 59 / var(--tw-ring-opacity));
}
.focus\\:ring-yellow-500\\/20:focus{
  --tw-ring-color: rgb(255 235 59 / 0.2);
}
.focus\\:ring-yellow-500\\/50:focus{
  --tw-ring-color: rgb(255 235 59 / 0.5);
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.active\\:scale-100:active{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-amber-500\\/30:active{
  background-color: rgb(255 193 7 / 0.3);
}
.active\\:bg-blue-500\\/30:active{
  background-color: rgb(33 150 243 / 0.3);
}
.active\\:bg-blue-gray-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.active\\:bg-blue-gray-500\\/30:active{
  background-color: rgb(96 125 139 / 0.3);
}
.active\\:bg-brown-500\\/30:active{
  background-color: rgb(121 85 72 / 0.3);
}
.active\\:bg-cyan-500\\/30:active{
  background-color: rgb(0 188 212 / 0.3);
}
.active\\:bg-deep-orange-500\\/30:active{
  background-color: rgb(255 87 34 / 0.3);
}
.active\\:bg-deep-purple-500\\/30:active{
  background-color: rgb(103 58 183 / 0.3);
}
.active\\:bg-gray-900\\/20:active{
  background-color: rgb(33 33 33 / 0.2);
}
.active\\:bg-green-500\\/30:active{
  background-color: rgb(76 175 80 / 0.3);
}
.active\\:bg-indigo-500\\/30:active{
  background-color: rgb(63 81 181 / 0.3);
}
.active\\:bg-light-blue-500\\/30:active{
  background-color: rgb(3 169 244 / 0.3);
}
.active\\:bg-light-green-500\\/30:active{
  background-color: rgb(139 195 74 / 0.3);
}
.active\\:bg-lime-500\\/30:active{
  background-color: rgb(205 220 57 / 0.3);
}
.active\\:bg-orange-500\\/30:active{
  background-color: rgb(255 152 0 / 0.3);
}
.active\\:bg-pink-500\\/30:active{
  background-color: rgb(233 30 99 / 0.3);
}
.active\\:bg-purple-500\\/30:active{
  background-color: rgb(156 39 176 / 0.3);
}
.active\\:bg-red-500\\/30:active{
  background-color: rgb(244 67 54 / 0.3);
}
.active\\:bg-teal-500\\/30:active{
  background-color: rgb(0 150 136 / 0.3);
}
.active\\:bg-transparent:active{
  background-color: transparent;
}
.active\\:bg-white\\/30:active{
  background-color: rgb(255 255 255 / 0.3);
}
.active\\:bg-yellow-500\\/30:active{
  background-color: rgb(255 235 59 / 0.3);
}
.active\\:bg-opacity-80:active{
  --tw-bg-opacity: 0.8;
}
.active\\:text-blue-gray-500:active{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.active\\:text-blue-gray-900:active{
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.active\\:opacity-\\[0\\.85\\]:active{
  opacity: 0.85;
}
.active\\:shadow-none:active{
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:resize-none:disabled{
  resize: none;
}
.disabled\\:border-0:disabled{
  border-width: 0px;
}
.disabled\\:bg-blue-gray-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:shadow-none:disabled{
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.peer:checked ~ .peer-checked\\:translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:border-amber-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-blue-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-brown-500{
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-cyan-500{
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-deep-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-deep-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-light-blue-500{
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-light-green-500{
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-lime-500{
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-orange-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-pink-500{
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-teal-500{
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:border-yellow-500{
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.peer:checked ~ .peer-checked\\:opacity-100{
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:before\\:bg-amber-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-blue-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-blue-gray-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-brown-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-cyan-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-deep-orange-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-deep-purple-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-gray-900::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(33 33 33 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-green-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-indigo-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 81 181 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-light-blue-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-light-green-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-lime-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-orange-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-pink-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(233 30 99 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-purple-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(156 39 176 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-red-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-teal-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 150 136 / var(--tw-bg-opacity));
}
.peer:checked ~ .peer-checked\\:before\\:bg-yellow-500::before{
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 235 59 / var(--tw-bg-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[3\\.75\\]{
  line-height: 3.75;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.1\\]{
  line-height: 4.1;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.25\\]{
  line-height: 4.25;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.875\\]{
  line-height: 4.875;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-tight{
  line-height: 1.25;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-blue-gray-500{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-green-500{
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-red-500{
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:before\\:border-transparent::before{
  content: var(--tw-content);
  border-color: transparent;
}
.peer:placeholder-shown ~ .peer-placeholder-shown\\:after\\:border-transparent::after{
  content: var(--tw-content);
  border-color: transparent;
}
.peer:focus ~ .peer-focus\\:text-\\[11px\\]{
  font-size: 11px;
}
.peer:focus ~ .peer-focus\\:text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.peer:focus ~ .peer-focus\\:leading-tight{
  line-height: 1.25;
}
.peer:focus ~ .peer-focus\\:text-\\[\\#163380\\]{
  --tw-text-opacity: 1;
  color: rgb(22 51 128 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-blue-gray-500{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-brown-500{
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-cyan-500{
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-deep-orange-500{
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-deep-purple-500{
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(33 33 33 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-green-500{
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(63 81 181 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-light-blue-500{
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-light-green-500{
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-lime-500{
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(233 30 99 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(156 39 176 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-red-500{
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-teal-500{
  --tw-text-opacity: 1;
  color: rgb(0 150 136 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(255 235 59 / var(--tw-text-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-l-2::before{
  content: var(--tw-content);
  border-left-width: 2px;
}
.peer:focus ~ .peer-focus\\:before\\:border-t-2::before{
  content: var(--tw-content);
  border-top-width: 2px;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-amber-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-black::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-gray-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-brown-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-cyan-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-orange-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-purple-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-gray-900::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-green-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-indigo-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-light-blue-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-light-green-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-lime-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-orange-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-pink-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-purple-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-red-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-teal-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-white::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:\\!border-yellow-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:before\\:border-green-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-indigo-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-pink-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-purple-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-red-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:before\\:border-teal-500::before{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:scale-x-100::after{
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:focus ~ .peer-focus\\:after\\:border-r-2::after{
  content: var(--tw-content);
  border-right-width: 2px;
}
.peer:focus ~ .peer-focus\\:after\\:border-t-2::after{
  content: var(--tw-content);
  border-top-width: 2px;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-amber-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-black::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 150 243 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-gray-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-brown-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-cyan-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-900::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(33 33 33 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(76 175 80 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-indigo-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 81 181 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-light-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-light-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-lime-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 152 0 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-pink-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(233 30 99 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(156 39 176 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-red-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-teal-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 150 136 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:\\!border-yellow-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 235 59 / var(--tw-border-opacity)) !important;
}
.peer:focus ~ .peer-focus\\:after\\:border-\\[\\#163380\\]::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(22 51 128 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-amber-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-black::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-blue-gray-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-brown-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-cyan-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-deep-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-deep-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-gray-900::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(33 33 33 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(76 175 80 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-indigo-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 81 181 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-light-blue-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-light-green-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-lime-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-orange-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 152 0 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-pink-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(233 30 99 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-purple-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(156 39 176 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-red-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-teal-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 150 136 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-white::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.peer:focus ~ .peer-focus\\:after\\:border-yellow-500::after{
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 235 59 / var(--tw-border-opacity));
}
.peer:disabled ~ .peer-disabled\\:text-blue-gray-400{
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.peer:disabled ~ .peer-disabled\\:text-transparent{
  color: transparent;
}
.peer:disabled ~ .peer-disabled\\:before\\:border-transparent::before{
  content: var(--tw-content);
  border-color: transparent;
}
.peer:disabled ~ .peer-disabled\\:after\\:border-transparent::after{
  content: var(--tw-content);
  border-color: transparent;
}
.peer:disabled:placeholder-shown ~ .peer-disabled\\:peer-placeholder-shown\\:text-blue-gray-500{
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
:is(.dark .dark\\:border-gray-700){
  --tw-border-opacity: 1;
  border-color: rgb(97 97 97 / var(--tw-border-opacity));
}
:is(.dark .dark\\:bg-white\\/10){
  background-color: rgb(255 255 255 / 0.1);
}
:is(.dark .dark\\:bg-white\\/5){
  background-color: rgb(255 255 255 / 0.05);
}
:is(.dark .dark\\:text-amber-400){
  --tw-text-opacity: 1;
  color: rgb(255 202 40 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-blue-400){
  --tw-text-opacity: 1;
  color: rgb(66 165 245 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-cyan-400){
  --tw-text-opacity: 1;
  color: rgb(38 198 218 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-gray-700){
  --tw-text-opacity: 1;
  color: rgb(97 97 97 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-green-400){
  --tw-text-opacity: 1;
  color: rgb(102 187 106 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-indigo-400){
  --tw-text-opacity: 1;
  color: rgb(92 107 192 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-lime-400){
  --tw-text-opacity: 1;
  color: rgb(212 225 87 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-orange-400){
  --tw-text-opacity: 1;
  color: rgb(255 167 38 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-pink-400){
  --tw-text-opacity: 1;
  color: rgb(236 64 122 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-purple-400){
  --tw-text-opacity: 1;
  color: rgb(171 71 188 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-red-400){
  --tw-text-opacity: 1;
  color: rgb(239 83 80 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-teal-400){
  --tw-text-opacity: 1;
  color: rgb(38 166 154 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
:is(.dark .dark\\:text-white\\/70){
  color: rgb(255 255 255 / 0.7);
}
:is(.dark .dark\\:text-white\\/80){
  color: rgb(255 255 255 / 0.8);
}
:is(.dark .dark\\:text-yellow-400){
  --tw-text-opacity: 1;
  color: rgb(255 238 88 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:bg-white\\/10:hover){
  background-color: rgb(255 255 255 / 0.1);
}
:is(.dark .dark\\:hover\\:text-amber-400:hover){
  --tw-text-opacity: 1;
  color: rgb(255 202 40 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-blue-400:hover){
  --tw-text-opacity: 1;
  color: rgb(66 165 245 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-cyan-400:hover){
  --tw-text-opacity: 1;
  color: rgb(38 198 218 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-green-400:hover){
  --tw-text-opacity: 1;
  color: rgb(102 187 106 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-indigo-400:hover){
  --tw-text-opacity: 1;
  color: rgb(92 107 192 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-lime-400:hover){
  --tw-text-opacity: 1;
  color: rgb(212 225 87 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-orange-400:hover){
  --tw-text-opacity: 1;
  color: rgb(255 167 38 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-pink-400:hover){
  --tw-text-opacity: 1;
  color: rgb(236 64 122 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-purple-400:hover){
  --tw-text-opacity: 1;
  color: rgb(171 71 188 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-red-400:hover){
  --tw-text-opacity: 1;
  color: rgb(239 83 80 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-teal-400:hover){
  --tw-text-opacity: 1;
  color: rgb(38 166 154 / var(--tw-text-opacity));
}
:is(.dark .dark\\:hover\\:text-yellow-400:hover){
  --tw-text-opacity: 1;
  color: rgb(255 238 88 / var(--tw-text-opacity));
}
:is(.dark .dark\\:focus\\:bg-white\\/10:focus){
  background-color: rgb(255 255 255 / 0.1);
}
@media (min-width: 576px) and (max-width: 767px){
  .sm\\:ml-0{
    margin-left: 0px;
  }
  .sm\\:hidden{
    display: none;
  }
  .sm\\:w-\\[15\\%\\]{
    width: 15%;
  }
  .sm\\:max-w-lg{
    max-width: 32rem;
  }
  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:flex-col{
    flex-direction: column;
  }
  .sm\\:gap-0{
    gap: 0px;
  }
  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .sm\\:pl-5{
    padding-left: 1.25rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px){
  .md\\:ml-0{
    margin-left: 0px;
  }
  .md\\:block{
    display: block;
  }
  .md\\:flex{
    display: flex;
  }
  .md\\:h-\\[55vh\\]{
    height: 55vh;
  }
  .md\\:max-h-\\[250px\\]{
    max-height: 250px;
  }
  .md\\:min-h-\\[220px\\]{
    min-height: 220px;
  }
  .md\\:w-1\\/3{
    width: 33.333333%;
  }
  .md\\:w-2\\/3{
    width: 66.666667%;
  }
  .md\\:w-3\\/4{
    width: 75%;
  }
  .md\\:w-3\\/5{
    width: 60%;
  }
  .md\\:w-5\\/6{
    width: 83.333333%;
  }
  .md\\:w-7{
    width: 1.75rem;
  }
  .md\\:w-\\[296px\\]{
    width: 296px;
  }
  .md\\:w-\\[40\\%\\]{
    width: 40%;
  }
  .md\\:w-auto{
    width: auto;
  }
  .md\\:min-w-\\[296px\\]{
    min-width: 296px;
  }
  .md\\:min-w-\\[60\\%\\]{
    min-width: 60%;
  }
  .md\\:min-w-\\[66\\.666667\\%\\]{
    min-width: 66.666667%;
  }
  .md\\:min-w-\\[75\\%\\]{
    min-width: 75%;
  }
  .md\\:min-w-\\[83\\.333333\\%\\]{
    min-width: 83.333333%;
  }
  .md\\:max-w-\\[60\\%\\]{
    max-width: 60%;
  }
  .md\\:max-w-\\[66\\.666667\\%\\]{
    max-width: 66.666667%;
  }
  .md\\:max-w-\\[75\\%\\]{
    max-width: 75%;
  }
  .md\\:max-w-\\[83\\.333333\\%\\]{
    max-width: 83.333333%;
  }
  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:flex-row{
    flex-direction: row;
  }
  .md\\:flex-col{
    flex-direction: column;
  }
  .md\\:gap-0{
    gap: 0px;
  }
  .md\\:space-x-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--tw-space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
  }
  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }
  .md\\:border-b{
    border-bottom-width: 1px;
  }
  .md\\:p-2{
    padding: 0.5rem;
  }
  .md\\:pl-1{
    padding-left: 0.25rem;
  }
  .md\\:pl-2{
    padding-left: 0.5rem;
  }
  .md\\:text-\\[26px\\]{
    font-size: 26px;
  }
}
@media (min-width: 1025px) and (max-width: 1280px){
  .lg\\:mb-0{
    margin-bottom: 0px;
  }
  .lg\\:h-10{
    height: 2.5rem;
  }
  .lg\\:h-\\[328px\\]{
    height: 328px;
  }
  .lg\\:h-\\[55vh\\]{
    height: 55vh;
  }
  .lg\\:w-10{
    width: 2.5rem;
  }
  .lg\\:w-2\\/4{
    width: 50%;
  }
  .lg\\:w-2\\/5{
    width: 40%;
  }
  .lg\\:w-3\\/4{
    width: 75%;
  }
  .lg\\:w-3\\/5{
    width: 60%;
  }
  .lg\\:w-\\[32\\%\\]{
    width: 32%;
  }
  .lg\\:w-auto{
    width: auto;
  }
  .lg\\:min-w-\\[40\\%\\]{
    min-width: 40%;
  }
  .lg\\:min-w-\\[50\\%\\]{
    min-width: 50%;
  }
  .lg\\:min-w-\\[60\\%\\]{
    min-width: 60%;
  }
  .lg\\:min-w-\\[75\\%\\]{
    min-width: 75%;
  }
  .lg\\:max-w-\\[40\\%\\]{
    max-width: 40%;
  }
  .lg\\:max-w-\\[50\\%\\]{
    max-width: 50%;
  }
  .lg\\:max-w-\\[60\\%\\]{
    max-width: 60%;
  }
  .lg\\:max-w-\\[75\\%\\]{
    max-width: 75%;
  }
  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-col{
    flex-direction: column;
  }
  .lg\\:justify-between{
    justify-content: space-between;
  }
  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }
  .lg\\:border-r{
    border-right-width: 1px;
  }
  .lg\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .lg\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:pr-1{
    padding-right: 0.25rem;
  }
  .lg\\:text-\\[20px\\]{
    font-size: 20px;
  }
  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 1281px) and (max-width: 1366px){
  .xl\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }
  .xl\\:h-\\[25vw\\]{
    height: 25vw;
  }
  .xl\\:h-\\[350px\\]{
    height: 350px;
  }
  .xl\\:h-\\[57vh\\]{
    height: 57vh;
  }
  .xl\\:w-\\[34\\.1\\%\\]{
    width: 34.1%;
  }
  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .xl\\:p-5{
    padding: 1.25rem;
  }
  .xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .xl\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .xl\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .xl\\:text-\\[26px\\]{
    font-size: 26px;
  }
}
@media (min-width: 1536px){
  .\\32xl\\:h-\\[28vw\\]{
    height: 28vw;
  }
  .\\32xl\\:h-\\[460px\\]{
    height: 460px;
  }
  .\\32xl\\:h-\\[65vh\\]{
    height: 65vh;
  }
  .\\32xl\\:w-1\\/3{
    width: 33.333333%;
  }
  .\\32xl\\:w-1\\/4{
    width: 25%;
  }
  .\\32xl\\:w-2\\/5{
    width: 40%;
  }
  .\\32xl\\:w-3\\/4{
    width: 75%;
  }
  .\\32xl\\:w-3\\/5{
    width: 60%;
  }
  .\\32xl\\:min-w-\\[25\\%\\]{
    min-width: 25%;
  }
  .\\32xl\\:min-w-\\[33\\.333333\\%\\]{
    min-width: 33.333333%;
  }
  .\\32xl\\:min-w-\\[40\\%\\]{
    min-width: 40%;
  }
  .\\32xl\\:min-w-\\[60\\%\\]{
    min-width: 60%;
  }
  .\\32xl\\:min-w-\\[75\\%\\]{
    min-width: 75%;
  }
  .\\32xl\\:max-w-\\[25\\%\\]{
    max-width: 25%;
  }
  .\\32xl\\:max-w-\\[33\\.333333\\%\\]{
    max-width: 33.333333%;
  }
  .\\32xl\\:max-w-\\[40\\%\\]{
    max-width: 40%;
  }
  .\\32xl\\:max-w-\\[60\\%\\]{
    max-width: 60%;
  }
  .\\32xl\\:max-w-\\[75\\%\\]{
    max-width: 75%;
  }
  .\\32xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .\\32xl\\:p-3{
    padding: 0.75rem;
  }
  .\\32xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .\\32xl\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .\\32xl\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .\\32xl\\:text-\\[18px\\]{
    font-size: 18px;
  }
  .\\32xl\\:text-\\[33px\\]{
    font-size: 33px;
  }
  .\\32xl\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 300px) and (max-width: 575px){
  .xs\\:ml-0{
    margin-left: 0px;
  }
  .xs\\:hidden{
    display: none;
  }
  .xs\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .xs\\:pl-5{
    padding-left: 1.25rem;
  }
}
@media (min-width: 1367px) and (max-width: 1535px){
  .\\31xl\\:h-\\[370px\\]{
    height: 370px;
  }
  .\\31xl\\:h-\\[58vh\\]{
    height: 58vh;
  }
  .\\31xl\\:w-\\[35\\%\\]{
    width: 35%;
  }
  .\\31xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .\\31xl\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:relative::-moz-range-thumb{
  position: relative;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:z-20::-moz-range-thumb{
  z-index: 20;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-1::-moz-range-thumb{
  margin-top: -0.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-\\[3px\\]::-moz-range-thumb{
  margin-top: -3px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-2\\.5::-moz-range-thumb{
  height: 0.625rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-3\\.5::-moz-range-thumb{
  height: 0.875rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-5::-moz-range-thumb{
  height: 1.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-2\\.5::-moz-range-thumb{
  width: 0.625rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-3\\.5::-moz-range-thumb{
  width: 0.875rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-5::-moz-range-thumb{
  width: 1.25rem;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb{
  appearance: none;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb{
  border-width: 0px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-white::-moz-range-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-2::-moz-range-thumb{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-current::-moz-range-thumb{
  --tw-ring-color: currentColor;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-moz-range-thumb{
  -webkit-appearance: none;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:h-full::-moz-range-track{
  height: 100%;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:rounded-full::-moz-range-track{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-moz-range-track\\]\\:bg-blue-gray-100::-moz-range-track{
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:h-full::-webkit-slider-runnable-track{
  height: 100%;
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:rounded-full::-webkit-slider-runnable-track{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:bg-blue-gray-100::-webkit-slider-runnable-track{
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:relative::-webkit-slider-thumb{
  position: relative;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:z-20::-webkit-slider-thumb{
  z-index: 20;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-1::-webkit-slider-thumb{
  margin-top: -0.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-\\[3px\\]::-webkit-slider-thumb{
  margin-top: -3px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-2\\.5::-webkit-slider-thumb{
  height: 0.625rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-3\\.5::-webkit-slider-thumb{
  height: 0.875rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5::-webkit-slider-thumb{
  height: 1.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2\\.5::-webkit-slider-thumb{
  width: 0.625rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3\\.5::-webkit-slider-thumb{
  width: 0.875rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5::-webkit-slider-thumb{
  width: 1.25rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb{
  appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-0::-webkit-slider-thumb{
  border-width: 0px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white::-webkit-slider-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-2::-webkit-slider-thumb{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-current::-webkit-slider-thumb{
  --tw-ring-color: currentColor;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-webkit-slider-thumb{
  -webkit-appearance: none;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;;CAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;CAAc;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,6IAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sDAAsD;EACtD,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAER,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;;;GAGG;;AAEH,kCAAkC;AAClC;EACE,gCAAgC;EAChC,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,iDAAiD;AACjD;;EAEE,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;AAClC;AAlIA;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,wBAkIC;EAlID,wDAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,4BAkIC;EAlID,wDAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,eAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,eAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,wBAkIC;EAlID,wDAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,8BAkIC;EAlID,wDAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,iBAkIC;EAlID,iBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,+BAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,+EAkIC;EAlID,mGAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,sCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,uCAkIC;EAlID;AAkIC;AAlID;EAAA,wCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,iBAkIC;EAlID,iBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,iCAkIC;EAlID,+CAkIC;EAlID;AAkIC;AAlID;EAAA,8BAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,2GAkIC;EAlID,yGAkIC;EAlID;AAkIC;AAlID;EAAA,2GAkIC;EAlID,yGAkIC;EAlID;AAkIC;AAlID;EAAA,2GAkIC;EAlID,yGAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,eAkIC;EAlID,eAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,iCAkIC;EAlID,+CAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,iCAkIC;EAlID,+CAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,kBAkIC;EAlID;AAkIC;AAlID;EAAA,mBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,mBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,eAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,iCAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID,sBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,0BAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,sBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA,oBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;AAAA;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,uBAkIC;IAlID,uDAkIC;IAlID;EAkIC;EAlID;IAAA,uBAkIC;IAlID,wDAkIC;IAlID;EAkIC;EAlID;IAAA,uBAkIC;IAlID,2DAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;AAAA;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,qBAkIC;IAlID;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,mBAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,kBAkIC;IAlID;EAkIC;AAAA;AAlID;EAAA;IAAA,iBAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,mBAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;AAAA;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,kBAkIC;IAlID;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,mBAkIC;IAlID;EAkIC;AAAA;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;AAAA;AAlID;EAAA;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA;EAkIC;EAlID;IAAA,oBAkIC;IAlID;EAkIC;EAlID;IAAA,mBAkIC;IAlID;EAkIC;AAAA;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,2GAkIC;EAlID,yGAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA,kBAkIC;EAlID;AAkIC;AAlID;EAAA,2GAkIC;EAlID,yGAkIC;EAlID;AAkIC;AAlID;EAAA;AAkIC;AAlID;EAAA;AAkIC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.top-bar li {\n  height: 25px;\n  border-radius: 5px;\n}\n\n.dashboard-card :hover {\n  /* background: #264390; */\n  width: '100%';\n}\n\n.dashboard-card :hover .visit-button {\n  background: #FFF;\n  color: #264390;\n}\n\n.dashboard-card :hover .visit-button button,\n.visit-icon {\n  background: #FFF;\n  color: #264390;\n}\n\n.dashboard-card :hover .visit-button button ,\n.visit-icon {\n  color: #264390;\n}\n\n.visit-button {\n  color: #fff;\n}\n\n.dashboardbutton :hover .visit-button , .visit-icon{\n  background: #FFF;\n  color: #264390;\n}\n\n@media (max-width: 1366px) {\n\n  .res_height {\n    height: 400px !important;\n  }\n}\n\n@media (-webkit-min-device-pixel-ratio: 0.80) {\n  .modal1 {\n    max-height: 20vw;\n  }\n}\n\n\ninput::placeholder {\n  color: gray;\n  opacity: 1;\n}\n\ninput[required]+label {\n  position: relative;\n  left: -170px;\n  /* move the label left and place it inside the input */\n  color: #757575;\n  /* placeholder color here */\n}\n\ninput[required]+label:after {\n  content: '*';\n  color: red;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important\n}\n\n.container-box {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.file_open {\n  transition: top 0.5s;\n  top: 150px;\n}\n\n.file_shrink_main:hover .file_open {\n  top: 90px;\n}\n\n/* .overflow-hidden{\n  overflow: visible !important;\n  overflow: auto !important;\n} */\n\n/* Alert Popup text wrapping fix */\n.alert-popup-message {\n  word-wrap: break-word !important;\n  overflow-wrap: break-word !important;\n  word-break: break-word !important;\n  max-width: 100% !important;\n  width: 100% !important;\n  white-space: normal !important;\n  overflow: hidden !important;\n  box-sizing: border-box !important;\n}\n\n/* Ensure Material Tailwind Alert content wraps */\n[class*=\"material-tailwind\"] .alert-content,\n[class*=\"material-tailwind\"] > div {\n  max-width: 100% !important;\n  overflow: hidden !important;\n  word-wrap: break-word !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
